import { useState, type CSSProperties, type InputHTMLAttributes } from "react";
import { useTranslation } from "react-i18next";
import Ic from "./icons.jsx";

/**
 * Password field with a show/hide toggle. Renders a plain `<input>` so the
 * auth screens keep their own inline styling; the toggle sits inside the
 * field on the right and never changes the field's size.
 */
export function PasswordInput({
  value, onChange, inputStyle, className, ...rest
}: Omit<InputHTMLAttributes<HTMLInputElement>, "type" | "value" | "onChange" | "style" | "className"> & {
  value: string;
  onChange: (value: string) => void;
  /** Style for the inner `<input>` (the wrapper is unstyled apart from positioning). */
  inputStyle?: CSSProperties;
  /** Class for the inner `<input>`. */
  className?: string;
}) {
  const { t } = useTranslation("auth");
  const [visible, setVisible] = useState(false);
  const label = visible ? t("password.hide", "Sakrij lozinku") : t("password.show", "Prikaži lozinku");
  return (
    <span className="pw-wrap">
      <input
        {...rest}
        type={visible ? "text" : "password"}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={className}
        style={inputStyle}
      />
      <button
        type="button"
        className="pw-toggle"
        onClick={() => setVisible((v) => !v)}
        aria-label={label}
        aria-pressed={visible}
        title={label}
        tabIndex={-1}
      >
        {visible ? <Ic.eyeOff /> : <Ic.eye />}
      </button>
    </span>
  );
}
